export default function initElementHeight() {
    document.querySelectorAll('.card').forEach(card => {
        const heading = card.querySelector('h3');
        
        function heightHandler() {
            heading && (
                card.style.setProperty('--headingHeight', `${heading.clientHeight/16}rem`)
            )
        }

        heightHandler();
        addEventListener("resize", heightHandler);
        addEventListener("orientationchange", heightHandler);
    })
}